import { useQuery } from "@tanstack/react-query";
import { checklistQuestionsService } from "../services";
import type {
	GetAllQuestionsParams,
	PaginatedChecklistQuestionResponse,
} from "../types";

export const useGetQuestions = (params: GetAllQuestionsParams) =>
	useQuery<PaginatedChecklistQuestionResponse>({
		queryKey: ["questions", params],
		queryFn: () => checklistQuestionsService.getAllQuestions(params),
	});

export const useGetQuestionsById = (id: string) =>
	useQuery({
		queryKey: ["questions", id],
		queryFn: () => checklistQuestionsService.getQuestionById(id),
		enabled: !!id,
	});
